import { render, staticRenderFns } from "./ListAutoCompetency.vue?vue&type=template&id=0b117e1c&scoped=true"
import script from "./ListAutoCompetency.vue?vue&type=script&lang=js"
export * from "./ListAutoCompetency.vue?vue&type=script&lang=js"
import style0 from "./ListAutoCompetency.vue?vue&type=style&index=0&id=0b117e1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b117e1c",
  null
  
)

export default component.exports